"use client";

import { useEffect, useState } from "react";
import { Dialog, DialogContent } from "./dialog";
import { Button } from "./button";

interface DynamicVariablesProps {
    isOpen: boolean;
    onClose: () => void;
    onSubmit: (variables: { [key: string]: string }) => void;
    response: { [key: string]: string };
}

export function DynamicVariables({
    isOpen,
    onClose,
    onSubmit,
    response,
}: DynamicVariablesProps) {
    const [updatedData, setUpdatedData] = useState<{ [key: string]: string }>({});

    useEffect(() => {
        if (isOpen) {
            setUpdatedData(response);
        }
    }, [isOpen, response]);

    const handleChange = (key: string, newValue: string) => {
        setUpdatedData((prev) => ({
            ...prev,
            [key]: newValue,
        }));
    };

    const handleSubmit = () => {
        onSubmit({ ...response, ...updatedData });
        onClose();
    };

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-[400px] grid content-center bg-[var(--lk-bg)] bg-white">
                <main
                    data-lk-theme="default"
                    className="h-full grid content-center bg-[var(--lk-bg)]"
                >
                    <div className="flex flex-col gap-4">
                        <div className="flex items-center justify-between">
                            <h2 className="text-lg">Set Dynamic Variables</h2>
                        </div>

                        <div className="max-h-[300px] overflow-y-auto pr-2">
                            {Object.entries(response).map(([key, value]) => (
                                <div key={key} className="flex flex-col gap-2 mb-4">
                                    <label>{key}</label>
                                    <input
                                        type="text"
                                        value={updatedData[key] ?? value ?? ""}
                                        onChange={(e) => handleChange(key, e.target.value)}
                                        className="border p-2 rounded w-full"
                                    />
                                </div>
                            ))}
                        </div>

                        <div className="btn-wrapper" style={{ paddingBottom: "0px" }}>
                            <Button
                                className="app-nurix-button flex flex-row items-center justify-center gap-1 hover:bg-blue-800"
                                onClick={handleSubmit}
                            >
                                Call
                            </Button>
                        </div>
                    </div>
                </main>
            </DialogContent>
        </Dialog>
    );
}
